module.exports = __webpack_public_path__ + "media/Indoor Billiard.e6072754.mp4";